import editProvider from '../stockRequest/editProvider';

function managThisProvider (provider, currentUser, stockState, setStockState, setManagProvider) {
    if (provider && provider !== "inconnu") {
        editProvider (currentUser, stockState, setStockState, setManagProvider, {tradeName: provider}, "read");
    }
}

export default managThisProvider;